import React from "react";
import { Link } from "react-router-dom";
import "../style/css/NotFoundPage.css";

// --- NotFoundPage Component (404) ---
export function NotFoundPage() {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        {/* Large 404 Number, styled with accent color */}
        <h1 className="not-found-code">404</h1>

        {/* Informative Heading */}
        <h2
          className="text-center"
          style={{
            marginBottom: "var(--space-sm)",
            color: "var(--color-secondary)",
          }}
        >
          ¡Página no encontrada!
        </h2>

        {/* Description */}
        <p
          className="text-center"
          style={{
            marginBottom: "var(--space-lg)",
            color: "var(--neutral-300)",
          }}
        >
          Lo sentimos, la dirección que intentaste visitar no existe o ha sido
          movida.
        </p>

        {/* Action Button to Home */}
        <Link
          to="/" // Link to your application's home or dashboard route
          className="btn btn--primary btn--large"
        >
          <i className="fas fa-home"></i>
          Volver a la Página Principal
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
